import './IongChartApp.scss';
import fnc from '../mymod/commFunction';
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import * as S from '../scss/theme';
import IgongChartScore from './IgongChartScore';
import IongChart1 from './IongChart1';
import IongChart2 from './IongChart2';
import HeaderTitle from '../comm/HeaderTitle';
import IgongChartDetail from './IgongChartDetail';
import IgongChartDetail_stu from './IgongChartDetail_stu';
import IgongChartTalent from './IgongChartTalent';
import IgongChartStudyMethod from './IgongChartStudyMethod';
import IgongChartMajorJinro from './IgongChartMajorJinro';
import IgongChartSchoolList from './IgongChartSchoolList';
import IgongChartOtherType from './IgongChartOtherType';
import IgongChartReadingBook from './IgongChartReadingBook';
import MainPageSub04_2 from './MainPageSub04_2';
import IgongMissionOrderResult from './IgongMissionOrderResult';
import HongButton from '../comm/HongButton';

const IongChartApp = () => {
  const selectedUserInfo = useSelector((state) => state.reduxIgong.selectedUserInfo);
  const selectedTestCode = useSelector((state) => state.reduxIgong.selectedTestCode);
  const navigate = useNavigate();

  const [title, setTitle] = useState('');
  const [dataSt, setDataSt] = useState([]);
  const [dataParent, setDataParent] = useState([]);
  const [radaData, setRadaData] = useState([]);
  const [studentRecord, setStudentRecord] = useState([]);
  const [parentRecord, setParentRecord] = useState([]);

  const [objAbefSt, setObjAbefSt] = useState({});
  const [objAbefParent, setObjAbefParent] = useState({});
  const [gradeCode, setGradeCode] = useState('');
  const [isJinroValue, setIsJinroValue] = useState('');
  const [studyJisu, setStudyJisu] = useState('');


  useEffect(() => {
    const stCode = selectedUserInfo.stCode;
    const userName = selectedUserInfo.userName;
    const parentCode = selectedUserInfo.parentCode;
    const gradeCode = selectedUserInfo.gradeCode;

    setGradeCode(gradeCode);
    // alert(gradeCode + " gradeCode")

    console.log(selectedUserInfo, '========= selectedUserInfo');

    setTitle(`${userName}의 REPORT`);
    fncGetScore_st(selectedTestCode, stCode);
    fncGetScore_parent(parentCode);


  }, []);

  function fncGetScore_st(testCode, stCode) {
    fnc.sendAxios('/igongAssess_chart/select/assessScore_st', { testCode, stCode }, (res) => {
      if (res && Array.isArray(res) && res.length > 0) {
        const newList = getRecords(res);
        const v = newList[0];
        setStudentRecord(newList);

        const values = [
          { name: '노벨', value: v.cntB * v.cntE },
          { name: '잡스', value: v.cntA * v.cntE },
          { name: '현대', value: v.cntA * v.cntF },
          { name: '유비', value: v.cntB * v.cntF },
        ];
        
        // 총합 구하기
        const total = values.reduce((sum, item) => sum + item.value, 0); 
        // 비율 추가
        const withPercent = values.map(item => ({
          ...item,
          percent: total > 0 ? Math.round((item.value / total) * 100)  : 0, // 소수 첫째 자리 반올림
        }));
      
        setDataSt(withPercent);

      } else {
        setStudentRecord([]);
        setDataSt([]);
        console.warn('학생 데이터 없음');
      }
    });

    function getRecords(res) {
      return res.map(r => ({
        sno: r.sno,
        testDate: r.testDate,
        parentCode: r.parentCode,
        stCode: r.stCode,
        userKind: r.userKind,
        cntA: r.cntA,
        cntB: r.cntB,
        cntE: r.cntE,
        cntF: r.cntF,
        testCode: r.testCode
      }));
    }
  }

  function fncGetScore_parent(stCode) {
    fnc.sendAxios('/igongAssess_chart/select/assessScore_parent', { stCode }, (res) => {
      if (res && Array.isArray(res) && res.length > 0) {
        const newList = getRecords(res);
        const v = newList[0];
        setParentRecord(newList);

        const values = [
          { name: '노벨', value: v.cntB * v.cntE },
          { name: '잡스', value: v.cntA * v.cntE },
          { name: '현대', value: v.cntA * v.cntF },
          { name: '유비', value: v.cntB * v.cntF },
        ];
        
        // 총합 구하기
        const total = values.reduce((sum, item) => sum + item.value, 0); 
        // 비율 추가
        const withPercent = values.map(item => ({
          ...item,
          percent: total > 0 ? Math.round((item.value / total) * 100) : 0
        }));
      
        setDataParent(withPercent);
        // // console.log(newList, 'newList');
        // setDataParent([
        //   { name: '노벨', value: v.cntB * v.cntE },
        //   { name: '잡스', value: v.cntA * v.cntE },
        //   { name: '현대', value: v.cntA * v.cntF },
        //   { name: '유비', value: v.cntB * v.cntF },
        // ]);
      } else {
        setParentRecord([]);
        setDataParent([]);
        console.warn('부모 데이터 없음');
      }
    });

    function getRecords(res) {
      return res.map(r => ({
        sno: r.sno,
        testDate: r.testDate,
        parentCode: r.parentCode,
        stCode: r.stCode,
        userKind: r.userKind,
        cntA: r.cntA,
        cntB: r.cntB,
        cntE: r.cntE,
        cntF: r.cntF,
        testCode: r.testCode
      }));
    }
  }

  useEffect(() => {
    if (studentRecord.length > 0 || parentRecord.length > 0) {
      const student = studentRecord[0] || {};
      const parent = parentRecord[0] || {};
      const res = buildExampleData(student, parent);
      setRadaData(res);
    }
  }, [studentRecord, parentRecord]);

  function buildExampleData(student, parent) {
    return [
      { subject: 'A', student: student.cntA ?? null, parent: parent.cntA ?? null },
      { subject: 'F', student: student.cntF ?? null, parent: parent.cntF ?? null },
      { subject: 'B', student: student.cntB ?? null, parent: parent.cntB ?? null },
      { subject: 'E', student: student.cntE ?? null, parent: parent.cntE ?? null },
    ];
  }

  return (
    <S.Section_frame>
      <S.Section_scroll>
      <HeaderTitle title={title} direction={1} onBackClick={() => navigate(-1)} />
      <div className="IongChartApp">
        <section className='sec-main'>

        
          <article className=''>
                {radaData.length > 0 && <IgongChartScore data={radaData} /> }      
          </article>


          <article className='art-chart'>
            {/* ✅ RadarChart - 조건부 렌더링 포함 */}

         
            <div className='box-chart'>

            <div className="memo memo-noteA">
              <p className='title'>잡스형</p>
              <p>주도적ㅣ비판력</p>
              <p>창의적ㅣ통찰력</p>
              <div className='box-percent'>
                <span className='percentSt'>{ dataParent.find(item => item.name === '잡스')?.percent ?? 0}%</span>
                <span className='percentMom'>{ dataSt.find(item => item.name === '잡스')?.percent ?? 0}%</span>
              </div>
            
            </div>

            <div className="memo memo-noteB">  
              <p>감성능력</p>
              <p>공감적ㅣ이해력</p>
              <div className='box-percent'>
                <span className='percentMom'>{ dataSt.find(item => item.name === '유비')?.percent ?? 0}%</span>
                <span className='percentSt'>{ dataParent.find(item => item.name === '유비')?.percent ?? 0}%</span>
              </div>
              <p className='title'>유비형</p>
            </div>

            <div className="memo memo-noteE">  
              <p>계획적ㅣ사고력</p>
              <p>논리적ㅣ이성능력</p>
              <div className='box-percent'>
                <span className='percentSt'>{ dataParent.find(item => item.name === '노벨')?.percent ?? 0}%</span>
                <span className='percentMom'>{ dataSt.find(item => item.name === '노벨')?.percent ?? 0}%</span>
              </div>
              <p className='title'>노벨형</p>
            </div>

            <div className="memo memo-noteF">
              <p className='title'>현대형</p>
              <p>활동적ㅣ표현력</p>
              <p>친화적ㅣ관계력</p>
              <div className='box-percent'>
                <span className='percentMom'>{ dataSt.find(item => item.name === '현대')?.percent ?? 0}%</span>
                <span className='percentSt'>{ dataParent.find(item => item.name === '현대')?.percent ?? 0}%</span>
              </div>
            </div>

              <IongChart2 data={radaData} />
            </div>

            {/* ✅ 부모 점수 차트 */}
            <div className='box-chart'>
              <IongChart1 chartTitle={'학부모 검사 결과'} data={dataParent} color={'green'} maxValue={121} />
            </div>

            {/* ✅ 학생 점수 차트 */}
            <div className='box-chart'>
              <IongChart1 chartTitle={'학생 검사 결과'} data={dataSt} color={'red'} maxValue={121} />
            </div>

          </article>

          <article className='art-chart-detail'>
            <div className='box-chart-detail'>
                {parentRecord.length > 0 && <IgongChartDetail data={parentRecord} /> }
            </div>

            <div className='box-chart-detail'>
                {studentRecord.length > 0 && <IgongChartDetail_stu data={studentRecord} /> }
            </div>
            
          </article>


          <article className='art-chart-talent'>
            <div className='box-chart-detail'>
                {studentRecord.length > 0 && <IgongChartTalent data={studentRecord} /> }
            </div>      
          </article>

          <article className='art-chart-otherType 학업역량기초평가'>
            <div className='box-chart-otherType'>
                 <IgongChartOtherType data={dataSt}/>
            </div>      
          </article>


          <article className='art-chart-studyMethod'>
            <div className='box-chart-studyMethod'>
                {studentRecord.length > 0 && <IgongChartStudyMethod data={studentRecord} /> }
            </div>      
          </article>

      

          <article className='art-chart-majorJinro'>
            <div className='box-chart-majorJinro'>
                {studentRecord.length > 0 && <IgongChartMajorJinro data={studentRecord} /> }
            </div>      
          </article>

          {/* 공부력 평가지수 */}
          <article className='art-chart-readingBook'>
            <div className='box-chart-readingBook'>
                {studentRecord.length > 0 && <IgongChartReadingBook data={dataSt} 
                setIsJinroValue={setIsJinroValue}
                setStudyJisu={setStudyJisu} /> }
            </div>      
          </article>


          <article className='art-chart-schoolList'>
            <div className='box-chart-schoolList'>
                {studentRecord.length > 0 && <IgongChartSchoolList data={studentRecord} /> }
            </div>      
          </article>
            {/* 미션오더 */}
          <article className='art-chart-schoolList'>
            <div className='box-chart-schoolList'>
                {studyJisu && isJinroValue && <IgongMissionOrderResult isJinroValue={isJinroValue} studyJisu={studyJisu} gradeCode={gradeCode} /> }
            </div>      
          </article>

         <article className='art-menu'>
            <HongButton className='btn btn-white' onClick={() => navigate(-1)}>이전으로</HongButton>
         </article>
                
        </section>
      </div>
      </S.Section_scroll>
    </S.Section_frame>
  );
};

export default IongChartApp;
